/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, DoCheck, Inject} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {FabMessageService} from '@fabric/components/message';
import {PlanningMarket} from '../../../../models/planning-market.model';
import {SelectableOptions} from '../../../../models/selectable-options';

@Component({
    selector: 'app-add-market-area-pop-up',
    templateUrl: './add-market-area-pop-up.component.html',
    styleUrls: ['./add-market-area-pop-up.component.scss'],
    standalone: false
})
export class AddMarketAreaPopUpComponent implements DoCheck {
  addMktAreaForm: FormGroup;
  title = 'Add';
  regionsPlanningMarketList: PlanningMarket[];
  displayedColumns: string[] = ['plngMkt'];
  dataSource: MatTableDataSource<string> = new MatTableDataSource(null);

  planningMarkets: SelectableOptions = new SelectableOptions();

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any,
              public dialogRef: MatDialogRef<AddMarketAreaPopUpComponent>,
              public snackBar: FabMessageService) {
    if (data) {
      if (!data.title) {
        this.dialogRef.close();
      }
      this.title = data.title;
      this.regionsPlanningMarketList = data.regionsPlanningMarketList;
      this.regionsPlanningMarketList.forEach(entry => this.planningMarkets.options.push(entry.plngMkt));
    }
    this.addMktAreaForm = new FormGroup({
      newValue: new FormControl(null, [Validators.required]),
      planningMarketMappingList: new FormControl(null, [Validators.required])
    });
    this.dataSource = new MatTableDataSource(this.addMktAreaForm.controls.planningMarketMappingList.value);
  }

  /**
   * Checks if the selected planning markets has changed, if so it updates the planning market list
   */
  ngDoCheck(): void {
    if (this.addMktAreaForm.controls.planningMarketMappingList.value !== this.planningMarkets.selectedOptions) {
      this.planningMarkets.selectedOptions = this.addMktAreaForm.controls.planningMarketMappingList.value;
      this.dataSource = new MatTableDataSource(this.addMktAreaForm.controls.planningMarketMappingList.value);
    }
  }

  /**
   * Close popup window.
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Return new values to add it to DB.
   */
  addValue(): void {
    this.dialogRef.close({
      data: {
        newValue: this.addMktAreaForm.controls.newValue.value,
        selectedPlanningMarkets: this.addMktAreaForm.controls.planningMarketMappingList.value
      }
    });
  }
}
